module.exports = __webpack_public_path__ + "img/setor-harian-kurir-red.e9ad2aea.svg";